import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  contentChild,
  ElementRef,
  effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoPremiumIconUI } from '../so-premium-icon/so-premium-icon.component';
import { SoButtonGradientUI } from '../so-button-gradient/so-button-gradient.component';
import { SoInputUI } from '../so-input/so-input.component';
import { SoTabsUI, SoTab } from '../so-tabs/so-tabs.component';

@Component({
  selector: 'so-header-actions-ui',
  standalone: true,
  imports: [CommonModule, SoPremiumIconUI, SoButtonGradientUI, SoInputUI, SoTabsUI],
  templateUrl: './so-header-actions.component.html',
  styleUrl: './so-header-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SoHeaderActionsUI {
  title = input<string>('');
  subtitle = input<string>('');
  headerIcon = input<string>('');
  headerIconColor = input<string>('--so-primary');
  showSearch = input<boolean>(false);
  searchPlaceholder = input<string>('Buscar...');
  showActionButton = input<boolean>(false);
  actionButtonText = input<string>('');
  actionButtonIcon = input<string>('');
  showTabs = input<boolean>(false);
  tabs = input<SoTab[]>([]);
  activeTabIndex = input<number>(0);
  showBorderBottom = input<boolean>(true);

  actionButtonClicked = output<void>();
  searchChanged = output<string>();
  tabChanged = output<number>();

  contentElement = contentChild<ElementRef>('content');
  hasContent = false;

  constructor() {
    effect(() => {
      const content = this.contentElement();
      if (content?.nativeElement) {
        this.hasContent = content.nativeElement.children.length > 0;
      }
    });
  }

  onActionButtonClick(): void {
    this.actionButtonClicked.emit();
  }

  onSearchChange(value: string): void {
    this.searchChanged.emit(value);
  }

  onTabChanged(index: number): void {
    this.tabChanged.emit(index);
  }
}
